import emitter from '@marvelapp/react-ab-test/lib/emitter';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Experiment from '@perpay-web/fintech/components/base/Experiment/Experiment';
import { getIsAuthenticated } from '@perpay-web/fintech/selectors/authentication';
import { analyticsMarkUnauthenticatedAbTestVariant } from '@perpay-web/services/abTesting';
import { analyticsMarkAuthenticatedAbTestVariant } from '@perpay-web/services/abTesting';

/** A drop-in replacement for Experiment that reports to
 * analytics when the component is mounted.
 *
 * Example:
 * <ReportingExperiment name={TEST_NAME}>
 *   <Variant name={VARIANT_A}></Variant>
 *   <Variant name={VARIANT_B}></Variant>
 * </ReportingExperiment>
 */
const ExperimentContainer = ({ name, children }) => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(getIsAuthenticated);

    const onMount = useCallback(() => {
        const reportAuthenticated = (value) =>
            dispatch(
                analyticsMarkAuthenticatedAbTestVariant({
                    experiment: name,
                    variant: value,
                }),
            );

        const reportUnauthenticated = (value) =>
            dispatch(
                analyticsMarkUnauthenticatedAbTestVariant({
                    experiment: name,
                    variant: value,
                }),
            );

        const report = isAuthenticated
            ? reportAuthenticated
            : reportUnauthenticated;

        report(name, emitter.getActiveVariant(name));
    }, [dispatch, isAuthenticated, name]);

    return (
        <Experiment name={name} onMount={onMount}>
            {children}
        </Experiment>
    );
};

export default ExperimentContainer;
